import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProcessLoader from "../ProcessLoader";
import { proxy } from "../../process/api";

const createEmptyMR = (id) => ({
  id,
  mr_id: "",
  name: "",
  hq: "",
  priorities: ["", "", ""],
  communication_rating: "",
  advice: ["", "", ""],
  month_target: "",
  secondary_sales_as_on30: "",
  expected_sales_next_month: "",
  closing_stock_as_on30: ""
});

const emptyDoctorRow = () => ({
  doctor_name: "",
  speciality: "",
  dml_no: "",

  hq: "",
  town: "",
  brand: ""
});

const naturalMonths = [
  "JANUARY",
  "FEBRUARY",
  "MARCH",
  "APRIL",
  "MAY",
  "JUNE",
  "JULY",
  "AUGUST",
  "SEPTEMBER",
  "OCTOBER",
  "NOVEMBER",
  "DECEMBER"
];

const AB01EDIT = () => {
  const navigate = useNavigate();
  const { draftid } = useParams();

  const [mrsList, setMrsList] = useState([]);
  const [mrs, setMrs] = useState([createEmptyMR(1)]);
  const [doctors, setDoctors] = useState(
    Array.from({ length: 10 }, emptyDoctorRow)
  );
  const [reportJSON, setReportJSON] = useState({});
  const [header, setHeader] = useState({});
  const [showProcessLoader, setShowProcessLoader] = useState(true);
  const [draftStatus, setDraftStatus] = useState('DRAFT');
  const [selfAssessment, setSelfAssessment] = useState({});
  const [mrAuditSheetStatus, setMrAuditSheetStatus] = useState([]);
  const [canDoFinal, setCanDoFinal] = useState(false);



  const handleSelfAssessmentUpdate = (e) => {
    const { name, value } = e.target;

    setSelfAssessment((prev) => ({
      ...prev,
      [name]: value
    }));
  };



  const getCurrentReport = async () => {
    

    const reportAPIreponse = await proxy(
      "/api/mis/abm/report/" + draftid,
      {},
      "get"
    );

    setReportJSON(reportAPIreponse || {});
    const mrAPIresponse = await proxy("/api/mis/psrlist?createdBy="+reportAPIreponse.report.created_by, {}, "get");
    setMrsList(mrAPIresponse?.data || []);

    setHeader(reportAPIreponse?.header || {});
    setDoctors(
      reportAPIreponse?.doctors?.length
        ? reportAPIreponse.doctors
        : Array.from({ length: 10 }, emptyDoctorRow)
    );

    setDraftStatus(reportAPIreponse.abm_draft_status.toUpperCase());
    setSelfAssessment(reportAPIreponse?.self_assessment || {});

    if (Array.isArray(reportAPIreponse?.mrs) && reportAPIreponse.mrs.length) {
      setMrs(
        reportAPIreponse.mrs.map((mr, idx) => ({
          ...createEmptyMR(idx + 1),
          ...mr
        }))
      );
    } else {
      setMrs([createEmptyMR(1)]);
    }


    const auditMetaList = await handleAuditData(reportAPIreponse.audit_report_id, mrAPIresponse?.data);
    console.log(auditMetaList);
    setShowProcessLoader(false);
  };

  useEffect(() => {
    getCurrentReport();

  }, []);

  useEffect(() => {

    setMrAuditSheetStatus((prev) => {
      const prevMap = new Map(
        prev.map((item, idx) => [String(item.mr_id || `row_${idx}`), item])
      );

      return (mrsList || []).map((mr, idx) => {
        const mrId = String(mr?.value || mr?.mr_id || `row_${idx}`);
        const existing = prevMap.get(mrId);
        return {
          mr_id: mrId,
          mr_name: mr?.name || "",
          status: typeof existing?.status === "string" ? existing.status : "UNKNOWN"
        };
      });
    });
  }, [mrsList]);


  useEffect(() => {
    const hasRows = Array.isArray(mrAuditSheetStatus) && mrAuditSheetStatus.length > 0;
    const allHaveAuditSheet =
      hasRows &&
      mrAuditSheetStatus.every((item) => item?.status === "HAS_AUDIT_SHEET");
    setCanDoFinal(allHaveAuditSheet);
  }, [mrAuditSheetStatus]);

  const canAddMoreMRs = Array.isArray(mrsList) && mrsList.length > 0 && mrs.length < mrsList.length;


  const addMR = () => {
    const max = Array.isArray(mrsList) ? mrsList.length : 0;
    if (!max) return;
    if (mrs.length >= max) return;

    setMrs((prev) => [...prev, createEmptyMR(prev.length + 1)]);
  };

  const updateMR = (index, field, value) => {
    const updated = [...mrs];
    updated[index][field] = value;
    setMrs(updated);
  };

  const updatePriority = (mrIdx, pIdx, value) => {
    const updated = [...mrs];
    updated[mrIdx].priorities[pIdx] = value;
    setMrs(updated);
  };

  const updateAdvice = (mrIdx, aIdx, value) => {
    const updated = [...mrs];
    updated[mrIdx].advice[aIdx] = value;
    setMrs(updated);
  };

  const addPriorityLine = (mrIdx) => {
    const updated = [...mrs];
    updated[mrIdx].priorities.push("");
    setMrs(updated);
  };

  const addAdviceLine = (mrIdx) => {
    const updated = [...mrs];
    updated[mrIdx].advice.push("");
    setMrs(updated);
  };

  const handleMRSelect = (mrIdx, selectedMrId) => {
    const updated = [...mrs];

    const selected = mrsList.find(
      (m) => String(m.value) === String(selectedMrId)
    );

    updated[mrIdx] = {
      ...updated[mrIdx],
      mr_id: selectedMrId,
      name: selected?.name || "",
      hq: selected?.hq?.toUpperCase() || ""
    };

    setMrs(updated);
  };

  const validateMrsSelected = () => {
    const missing = mrs
      .map((mr, idx) => ({ idx, mr }))
      .filter(({ mr }) => !String(mr.mr_id || "").trim());

    if (missing.length) {
      const nums = missing.map((x) => x.idx + 1).join(", ");
      alert(`Please select MR for section(s): ${nums}`);
      return false;
    }
    return true;
  };


  const selectedMrIds = new Set(
    mrs.map((x) => String(x.mr_id || "")).filter(Boolean)
  );

  const isMrTakenElsewhere = (currentIdx, optionValue) => {
    const v = String(optionValue);
    if (!v) return false;
    return mrs.some((row, idx) => idx !== currentIdx && String(row.mr_id) === v);
  };

  const updateDoctor = (row, field, value) => {
    const updated = [...doctors];
    updated[row][field] = value;
    setDoctors(updated);
  };

  const addDoctorRow = () => {
    setDoctors([...doctors, emptyDoctorRow()]);
  };

  const handleFinalDraft = async () => {
    if (!validateMrsSelected()) return;
    document.getElementById('saveFinalReport').innerHTML = "SAVING...";

    const payload = {
      abm_draft_id: reportJSON.abm_draft_id,
      abm_draft_status: "Draft",
      report: reportJSON.report,
      header,
      mrs: mrs.map(({ id, ...mr }) => mr),
      doctors,
      self_assessment: selfAssessment
    }; 

    const mrAPIresponse = await proxy("/api/mis/abm/report/updatedraft", payload, "post");
    console.log(mrAPIresponse);
    await new Promise(resolve => setTimeout(resolve, 2000));
    await finalProcessAudit();
    const finalAPIresponse = await proxy("/api/mis/abm/report/savefinaldraft/" + reportJSON.abm_draft_id, {}, "post");

    console.log(finalAPIresponse);
    if (finalAPIresponse.abm_draft_status.toUpperCase() == "FINAL") {
      setDraftStatus('FINAL');
      alert("Report Finalised");
    }
    document.getElementById('saveFinalReport').innerHTML = "CREATE FINAL";


  };

  const finalProcessAudit = async () => {
    const currentAuditReportId = reportJSON?.audit_report_id;
    const psrIds = (mrAuditSheetStatus || [])
      .map((item) => String(item?.mr_id || "").trim())
      .filter(Boolean);

    if (!currentAuditReportId || !psrIds.length) {
      return;
    }

    for (const psrId of psrIds) {
      await proxy(
        `/api/mis/abm/report/savefinalchemistaudit/${currentAuditReportId}/${psrId}`,
        {},
        "post"
      );
    }
  };


  const handleSaveDraft = async () => {
    if (!validateMrsSelected()) return;

    document.getElementById('saveDraftBtn').innerHTML = "SAVING...";

    const payload = {
      abm_draft_id: reportJSON.abm_draft_id,
      abm_draft_status: "Draft",
      report: reportJSON.report,
      header,
      mrs: mrs.map(({ id, ...mr }) => mr),
      doctors,
      self_assessment: selfAssessment
    };

    const mrAPIresponse = await proxy("/api/mis/abm/report/updatedraft", payload, "post");
    document.getElementById('saveDraftBtn').innerHTML = "SAVE DRAFT";
    alert("Report Saved");

  };

  const handleAuditData = async (auditReportId, mrsList) => {


    const mrIds = (mrsList || [])
      .map((mr) => String(mr?.value ?? mr?.mr_id ?? "").trim())
      .filter(Boolean);

    if (!mrIds.length) {
      console.warn("No MR IDs available in mrsList");
      return [];
    }

    const auditMetaList = await Promise.all(
      mrIds.map(async (mrId) => {
        try {
          const meta = await proxy(
            `/api/mis/abm/getauditreportmeta/${auditReportId}/${mrId}`,
            {},
            "get"
          );
          return { mr_id: mrId, meta, error: null };
        } catch (error) {
          console.error(`Failed for MR ID ${mrId}`, error);
          return { mr_id: mrId, meta: null, error };
        }
      })
    );

    const mrNameMap = new Map(
      (mrsList || []).map((mr) => [String(mr?.value ?? mr?.mr_id ?? ""), mr?.name || ""])
    );

    setMrAuditSheetStatus(
      auditMetaList.map((item) => {
        const innerSheetIds = Array.isArray(item?.meta?.auditInnerSheetIds)
          ? item.meta.auditInnerSheetIds
          : null;

        return {
          mr_id: item.mr_id,
          mr_name: mrNameMap.get(String(item.mr_id)) || "",
          status:
            innerSheetIds && innerSheetIds.length === 0
              ? "NOT_STARTED"
              : innerSheetIds && innerSheetIds.length > 0
                ? "HAS_AUDIT_SHEET"
                : "UNKNOWN"
        };
      })
    );


    return auditMetaList;
  };


  const handleSaveAndSwitchAudit = async () => {
    if (!validateMrsSelected()) return;

    if (draftStatus == "FINAL") {
      navigate("/abm-report-chemist-audit/" + reportJSON.audit_report_id + "/" + reportJSON.report?.created_by);
    } else {
      document.getElementById('saveDraftBtn').innerHTML = "SAVING...";

      const payload = {
        abm_draft_id: reportJSON.abm_draft_id,
        abm_draft_status: "Draft",
        report: reportJSON.report,
        header,
        mrs: mrs.map(({ id, ...mr }) => mr),
        doctors,
        self_assessment: selfAssessment
      };

      const mrAPIresponse = await proxy("/api/mis/abm/report/updatedraft", payload, "post");
      document.getElementById('saveDraftBtn').innerHTML = "SAVE DRAFT";
      navigate("/abm-report-chemist-audit/" + reportJSON.audit_report_id + "/" + reportJSON.report?.created_by);
    }


  };

  return (
    <div className="main-content">
      {showProcessLoader ? (
        <ProcessLoader />
      ) : (
        <>
          <div className="row">
            <div className="col-12">
              <div className="card report-card">
                <div className="card-title report-card-title">
                  CREATE NEW ABM REPORT
                  <button
                    className="btn btn-outline btn-sm mr-10 fw-500"
                    onClick={() => navigate("/abm-report-01")}
                  >
                    BACK
                  </button>
                </div>

                <div className="card-body">
                  <div id="abm-report-01">
                    <div className="page" style={{ width: "90%", padding: 0, maxWidth: "auto" }}>
                      <div className="logo-area">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                          }}
                        >
                          <div>
                            <img
                              src="/images/logo.png"
                              style={{
                                filter: "grayscale(1)",
                                maxWidth: "300px",
                                marginBottom: "20px"
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="title">
                        Monthly Development Report - ABM
                      </div>

                      <div className="center-text">
                        (Month :
                        <span className="underline">
                          {
                            naturalMonths[
                            Number(
                              String(reportJSON?.report?.month).slice(4)
                            ) - 1
                            ]
                          }&nbsp;
                          {reportJSON?.report?.month.toString().slice(0, 4)}
                        </span>
                        )
                      </div>

                      <div className="center-text">
                        (To be submitted before 5<sup>th</sup> of every month)
                      </div>

                      <div className="info-box">
                        <div className="info-grid">
                          <div className="info-row">
                            <div className="label">From :</div>
                            <div>
                              Mr.{" "}
                              <span className="bold">
                                {header?.fromName}
                              </span>{" "}
                              : {header?.designation}
                            </div>
                          </div>

                          <div className="info-row">
                            <div className="label">TO :</div>
                            <div>
                              {header?.to
                                ? header.to.toUpperCase()
                                : "__________"}
                            </div>
                          </div>

                          <div className="info-row">
                            <div className="label">H.Q. :</div>
                            <div>
                              {header?.hq
                                ? header.hq.toUpperCase()
                                : "__________"}
                            </div>
                          </div>

                          <div className="info-row">
                            <div className="label">CC :</div>
                            <div>
                              {header?.cc
                                ? header.cc.toUpperCase()
                                : "__________"}
                            </div>
                          </div>

                          <div className="info-row">
                            <div className="label">DIV / BRANCH :</div><div>&nbsp;
                              {JSON.parse(localStorage.getItem('div_data')).data.find(depos => depos.value == reportJSON.report.div_code).name}&nbsp; / &nbsp;
                              {JSON.parse(localStorage.getItem('depo_data')).data.find(depos => depos.value == reportJSON.report.depo_code).name}
                            </div>
                          </div>

                          <div className="info-row">
                            <div className="label">DATE :</div>
                            <div>
                              {header.date
                              }
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="section-title">
                        Top 3 Priorities for the month of each MR/PSR or FO/FSO of
                        your team
                      </div>

                      {mrs.map((mr, idx) => (
                        <div className="mr-block" key={mr.id}>
                          <div className="mr-header">
                            {idx + 1}) Name of the MR/PSR or FO/FSO&nbsp;
                            <select
                              value={mr.mr_id}
                              onChange={(e) => handleMRSelect(idx, e.target.value)}
                            >
                              <option value="">Select MR</option>
                              {mrsList.map((m) => {
                                const v = String(m.value);
                                const disabled = isMrTakenElsewhere(idx, v);

                                return (
                                  <option key={v} value={v} disabled={disabled}>
                                    {m.name}
                                  </option>
                                );
                              })}
                            </select>
                            &nbsp;&nbsp;H.Q.&nbsp;
                            <input
                              value={
                                mr?.hq
                                  ? mr.hq.toUpperCase()
                                  : ""
                              }
                              readOnly
                              style={{ fontWeight: "bold" }}
                            />
                          </div>

                          {mr.priorities.map((p, pIdx) => (
                            <div className="priority" key={pIdx}>
                              <span className="priority-label">
                                {["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][pIdx]})
                              </span>
                              <input
                                className="priority-text"
                                value={p}
                                onChange={(e) =>
                                  updatePriority(
                                    idx,
                                    pIdx,
                                    e.target.value
                                  )
                                }
                              />

                            </div>
                          ))}
                          <button
                            className="btn  btn-dark btn-sm "
                            style={{ margin: "auto", display: "block" }}
                            onClick={() => addPriorityLine(idx)}
                          >
                            + Add Priority Line
                          </button>
                        </div>
                      ))}

                      <button
                        className="btn btn-bold btn-info"
                        onClick={addMR}
                        disabled={!canAddMoreMRs}
                        title={
                          !Array.isArray(mrsList) || !mrsList.length
                            ? "MR list is not loaded yet"
                            : !canAddMoreMRs
                              ? `Maximum ${mrsList.length} MR(s) can be added`
                              : ""
                        }>+ Add Another MR
                      </button>

                      <div className="section-title" style={{ marginTop: 35 }}>
                        II) COMMUNICATION / DETAILING SKILL
                      </div>

                      <table id="ratingTable">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>NAME OF MR / PSR</th>
                            <th>HQ</th>
                            <th>Rating (1-10)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mrs.map((mr, idx) => (
                            <tr key={mr.id}>
                              <td>{idx + 1}</td>
                              <td>{mr.name}</td>
                              <td>
                                {mr?.hq
                                  ? mr.hq.toUpperCase()
                                  : ""}
                              </td>
                              <td>
                                <input
                                  value={mr.communication_rating}
                                  onChange={(e) =>
                                    updateMR(
                                      idx,
                                      "communication_rating",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <p>
                        # (Rating 10 as the highest & 1 as lowest)
                      </p>
                      <p>
                        Self Rating :
                        <input
                          className="input-byline"
                          name="self_rating"
                          style={{ width: "100px", marginRight: "20px" }}
                          value={selfAssessment.self_rating || ""}
                          onChange={handleSelfAssessmentUpdate}
                        />

                        Self Improvement Plan:

                        <input
                          className="input-byline"
                          style={{ width: "421px" }}
                          name="self_improvement_plan"
                          value={selfAssessment.self_improvement_plan || ""}
                          onChange={handleSelfAssessmentUpdate}
                        />


                      </p>

                      <div className="section-title" style={{ marginTop: 40 }}>
                        ADVISE GIVEN TO EACH MR/PSR ON DETAILING IMPROVEMENT
                      </div>

                      {mrs.map((mr, idx) => (
                        <div className="advice-block" key={mr.id}>
                          <div className="advice-header">
                            {idx + 1}) Name of the MR/PSR or FO/FSO&nbsp; <strong style={{ fontWeight: 800 }}>Mr.{" "}
                              {mr.name || "__________"} &nbsp;&nbsp; H.Q.{" "}
                              {header?.hq
                                ? header.hq.toUpperCase()
                                : ""}</strong>
                          </div>

                          {mr.advice.map((a, aIdx) => (
                            <input
                              key={aIdx}
                              className="advice-input"
                              value={a}
                              onChange={(e) =>
                                updateAdvice(
                                  idx,
                                  aIdx,
                                  e.target.value
                                )
                              }
                            />
                          ))}

                          <button
                            className="btn  btn-dark btn-sm "
                            style={{ margin: "auto", display: "block" }}
                            onClick={() => addAdviceLine(idx)}
                          >
                            + Add Advice Line
                          </button>
                        </div>
                      ))}

                      <div className="section-title" style={{ marginTop: 40 }}>
                        III) MENTION HEREBELOW THE DOCTORS & THE NAME OF THE BRAND
                        THEY HAVE STARTED PRESCRIBING
                      </div>

                      <table id="doctorTable">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name of Dr</th>
                            <th>Speciality</th>
                            <th>DML No.</th>

                            <th>HQ</th>
                            <th>Town</th>
                            <th>Brand</th>
                          </tr>
                        </thead>
                        <tbody>
                          {doctors.map((d, idx) => (
                            <tr key={idx}>
                              <td>{idx + 1}</td>
                              {Object.keys(d).map((key) => (
                                <td key={key}>
                                  <input
                                    value={d[key]}
                                    onChange={(e) =>
                                      updateDoctor(
                                        idx,
                                        key,
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <button className="btn  btn-dark btn-sm  mt-2"
                        style={{ margin: "auto", display: "block" }} onClick={addDoctorRow}>
                        + Add Row
                      </button>

                      <div className="section-title" style={{ marginTop: 40 }}>
                        V) SALES UPDATE AND FORECAST (for Forthcoming Month)
                      </div>

                      <table id="salesTable">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name of MR</th>
                            <th>HQ</th>
                            <th>MONTH TGT</th>
                            <th>SEC SALES {naturalMonths[
                              Number(String(reportJSON?.report?.month).slice(4)) - 1
                            ].slice(0, 3)}</th>
                            <th>CLOSING STOCK {naturalMonths[
                              Number(String(reportJSON?.report?.month).slice(4)) - 1
                            ].slice(0, 3)}</th>
                            <th>EXPECTED SALES NEXT MONTH</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mrs.map((mr, idx) => (
                            <tr key={mr.id}>
                              <td>{idx + 1}</td>
                              <td>{mr.name}</td>
                              <td>
                                {header?.hq
                                  ? header.hq.toUpperCase()
                                  : ""}
                              </td>
                              <td>
                                <input
                                  value={mr.month_target}
                                  onChange={(e) =>
                                    updateMR(
                                      idx,
                                      "month_target",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  value={mr.secondary_sales_as_on30}
                                  onChange={(e) =>
                                    updateMR(
                                      idx,
                                      "secondary_sales_as_on30",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  value={mr.closing_stock_as_on30}
                                  onChange={(e) =>
                                    updateMR(
                                      idx,
                                      "closing_stock_as_on30",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  value={
                                    mr.expected_sales_next_month
                                  }
                                  onChange={(e) =>
                                    updateMR(
                                      idx,
                                      "expected_sales_next_month",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <p>&nbsp;</p><p>&nbsp;</p>

                  <div className="d-flex justify-content-center align-items-center mb-5">


                    <div id="statusCheck">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th style={{ width: "60px" }}>#</th>
                            <th>PSR</th>
                            <th>Audit Sheet Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mrAuditSheetStatus.map((item, idx) => (
                            <tr key={`status_${item.mr_id || idx}`}>
                              <td>{idx + 1}</td>
                              <td>{item.mr_name || ""}</td>
                              <td>{item.status}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                  </div> <div className="d-flex justify-content-center align-items-center mb-5">
                    <button
                      className="btn btn-primary-outline btn-md ml-2"
                      onClick={async () => {
                        await handleSaveAndSwitchAudit();            // waits

                      }}
                    >
                      View Chemist Audit Sheet
                    </button>
                  </div>
                </div>

                <div className="card-footer">

                  <button
                    className="btn btn-outline btn-primary-outline  fw-500"
                    onClick={() => navigate("/abm-report-01")}
                  >
                    BACK
                  </button>

                  {draftStatus == "FINAL" ?
                    <button className="btn btn-primary btn-md ml-2"
                      onClick={() => { navigate("/abm-report-01-view/" + reportJSON.abm_draft_id) }}
                    >
                      View Report
                    </button>
                    :
                    <>
                      <button
                        id="saveDraftBtn"
                        className="btn btn-primary btn-md ml-2"
                        onClick={handleSaveDraft}
                        disabled={draftStatus != "DRAFT"}
                      >
                        SAVE DRAFT
                      </button>

                      <button
                        id="saveFinalReport"
                        className="btn btn-primary btn-md ml-2"
                        onClick={handleFinalDraft}
                        disabled={draftStatus != "DRAFT" || !canDoFinal}
                      >
                        CREATE FINAL
                      </button>
                    </>
                  }
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AB01EDIT;
